import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/detached-triggers-controlled/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/detached-triggers-controlled/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/detached-triggers-simple/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/detached-triggers-simple/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/focus-management/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/focus-management/tailwind/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/hero/css-modules/index.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/nested/css-modules/index.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/inside-scroll/css-modules/index.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/open-from-menu/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/open-from-menu/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/outside-scroll/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/outside-scroll/tailwind/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlockPreComputedContent"] */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlockPreComputedContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Demo"] */ "/opt/build/repo/docs/src/components/Demo/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Link.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/HeadingLink.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Kbd/Kbd.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/dialog/demos/uncontained/css-modules/index.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/QuickNav/QuickNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferenceTable"] */ "/opt/build/repo/docs/src/components/ReferenceTable/ReferenceTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarkdownLink"] */ "/opt/build/repo/docs/src/components/Subtitle/MarkdownLink.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Subtitle/Subtitle.css");
;
import(/* webpackMode: "eager", webpackExports: ["ViewSourceLink"] */ "/opt/build/repo/docs/src/components/Subtitle/ViewSourceLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root","Head","Body","Row","RowHeader","ColumnHeader","Cell"] */ "/opt/build/repo/docs/src/components/Table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypePropRef"] */ "/opt/build/repo/docs/src/components/TypePropRef/TypePropRef.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypeRef"] */ "/opt/build/repo/docs/src/components/TypeRef/TypeRef.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/css/mdx-components.css");
;
import(/* webpackMode: "eager", webpackExports: ["DemoRootProvider"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.13.1-canary.17_@types+react@19.3.0_next@16.4.1_@babel+core@8_490be55d419e2052e72b400fc06a6cd4/node_modules/@mui/internal-docs-infra/abstractCreateDemo/DemoRootContext.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["TypeCode"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.13.1-canary.17_@types+react@19.3.0_next@16.4.1_@babel+core@8_490be55d419e2052e72b400fc06a6cd4/node_modules/@mui/internal-docs-infra/abstractCreateTypes/TypeCode.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.13.1-canary.17_@types+react@19.3.0_next@16.4.1_@babel+core@8_490be55d419e2052e72b400fc06a6cd4/node_modules/@mui/internal-docs-infra/CodeHighlighter/CodeHighlighterClient.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useCodeFallback"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.13.1-canary.17_@types+react@19.3.0_next@16.4.1_@babel+core@8_490be55d419e2052e72b400fc06a6cd4/node_modules/@mui/internal-docs-infra/CodeHighlighter/useCodeFallback.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["CoordinatedLazyClient"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.13.1-canary.17_@types+react@19.3.0_next@16.4.1_@babel+core@8_490be55d419e2052e72b400fc06a6cd4/node_modules/@mui/internal-docs-infra/CoordinatedLazy/CoordinatedLazyClient.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.4.1_@babel+core@8.0.7_@playwright+test@1.64.0_@types+node@22.20.5_babel-plugin-_4173389034d7ddf18b7a6383801703b5/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["DialogBackdrop"] */ "/opt/build/repo/packages/react/src/dialog/backdrop/DialogBackdrop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogClose"] */ "/opt/build/repo/packages/react/src/dialog/close/DialogClose.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogDescription"] */ "/opt/build/repo/packages/react/src/dialog/description/DialogDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogPopup"] */ "/opt/build/repo/packages/react/src/dialog/popup/DialogPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogPortal"] */ "/opt/build/repo/packages/react/src/dialog/portal/DialogPortal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogRoot"] */ "/opt/build/repo/packages/react/src/dialog/root/DialogRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogTitle"] */ "/opt/build/repo/packages/react/src/dialog/title/DialogTitle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogTrigger"] */ "/opt/build/repo/packages/react/src/dialog/trigger/DialogTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogViewport"] */ "/opt/build/repo/packages/react/src/dialog/viewport/DialogViewport.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["attachPreventUnmountOnClose"] */ "/opt/build/repo/packages/react/src/utils/popups/popupStoreUtils.ts");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/utils/src/store/ReactStore.ts");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/utils/src/store/StoreInspector.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/utils/src/useAnimationFrame.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useRefWithInit"] */ "/opt/build/repo/packages/utils/src/useRefWithInit.ts");
